;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import { graphRequest } from 'services/contentful';

import {
    assetFragment,
    ctaFragment,
    linkFragment,
} from 'lib/graphql/fragments';

import BlockImageNavTile from './BlockImageNavTile';

const query = /* GraphQL */ `
    ${assetFragment}
    ${ctaFragment}
    ${linkFragment}
    query getBlock($id: String!, $preview: Boolean!) {
        blockImageNavTile(preview: $preview, id: $id) {
            __typename
            anchorId
            title1
            titleColor1
            cta1 {
                ...CTA
            }
            image1 {
                ...Asset
            }
            title2
            titleColor2
            cta2 {
                ...CTA
            }
            image2 {
                ...Asset
            }
            flushTop
            flushBottom
        }
    }
`;

async function fetchBlock(id) {
    const {
        body: {
            data: { blockImageNavTile },
        },
    } = await graphRequest({
        query,
        variables: { id },
    });
    return blockImageNavTile;
}

const BlockImageNavTileServer = async ({ id, ...rest }) => {
    const block = await fetchBlock(id);

    return <BlockImageNavTile {...block} {...rest} />;
};

export default BlockImageNavTileServer;
